import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap5';

import StepTab from 'components/new_ui/Tabs/StepTab';
import { useContext as useTeamContext } from 'components/Managers/Teams/Context';
import Head from './Head';
import Form from './Form';
import Footer from './Footer';
import MemberItem from './MemberItem';

export default function Index() {
  const { state: stateTeam } = useTeamContext();
  const [members, setMembers] = useState(JSON.parse(localStorage.getItem('manualCreateMmebers') || '[]'));

  const teams = stateTeam && stateTeam.teams ? stateTeam.teams.map((item) => ({
    label: item.attributes.title,
    value: item.id,
  })) : [];

  const addMember = (member) => {
    if (members.find((item) => item.email === member.email)) {
      return false;
    }
    const newMembers = [...members, member];
    setMembers(newMembers);
    return true;
  };

  const removeMember = (member) => {
    const newMembers = members.filter((item) => item.email !== member.email);
    setMembers(newMembers);
  };

  const removeMembersAfterImport = (data) => {
    let newMembers = [...members];

    const isError = data.some((item) => item.status === 'error');

    data.forEach((member) => {
      if (member.status === 'ok') {
        if (!isError) {
          newMembers = newMembers.filter((item) => item.email !== member.email && item.email !== member.raw_email);
        }
      } else {
        const record = newMembers.find((item) => item.email === member.email || item.email === member.raw_email);
        if (record) {
          record.error = member.messages.join(',');
        }
      }
    });
    if (isError) {
      newMembers.sort((a) => {
        if (a.error) {
          return -1;
        }
        return 0;
      });
    }
    setMembers(newMembers);
    return newMembers.length === 0;
  };

  useEffect(() => {
    localStorage.setItem('manualCreateMmebers', JSON.stringify(members || []));
  }, [members]);

  return (
    <>
      <StepTab total={3} current={2} />

      <div className="content">
        <Head />

        <section>
          <Row>
            <Col md={6}>
              <h3>Form</h3>

              <Form addMember={addMember} teams={teams} />
            </Col>

            <Col md={6} className="mt-4 mt-md-0">
              <h3>Member List</h3>

              {members.length === 0 && (
                <div className="card border-light bg-light text-dark text-center">
                  <div className="card-body">
                    <p className="card-text my-5">Your member list will start here.</p>
                  </div>
                </div>
              )}

              {members.length > 0 && (
                <div className="pe-2" style={{ height: '450px', overflowY: 'auto' }}>
                  {members.map((member) => (
                    <MemberItem
                      key={member.email + member.error}
                      member={member}
                      removeMember={removeMember}
                      teams={teams}
                    />
                  ))}
                </div>
              )}
            </Col>
          </Row>
        </section>

        <Footer members={members} removeMembersAfterImport={removeMembersAfterImport} />
      </div>
    </>
  );
}
